import React, {useState, useEffect, useCallback, Fragment} from 'react'
import * as RouterActions from '../../actions/RouterActions'
import * as StoriesActions from '../../actions/StoriesActions'
import {Menu, Loader, Icon, Button, Popup} from 'semantic-ui-react'
import {useFirebase, useFirestore, useFirestoreConnect} from 'react-redux-firebase';
import {useDispatch, useSelector} from 'react-redux';
import Dropzone from 'react-dropzone';
import * as moment from 'moment'
import {env} from '../../constants/Environment';
import { nanoid } from 'nanoid'
import {StoriesNavigation} from './Navigation';
import * as Elements from './Elements';
import {Sidebar} from './Sidebar';

const _ = require('lodash');

export function debounce(func, wait, immediate) {
  var timeout;

  return (...args) => {
    var context = this;

    var later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}

const ElementWrapper = (props) => {
    const [hover, setHover] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        if(!props.readonly && (typeof props.element.version_saved === 'undefined' || props.element.version_saved === null || props.element.version > props.element.version_saved)){
            save(props.storyId, props.draftId, props.idx, props.element.version, _.pick(props.element, ['idx', 'payload', 'type', 'is_deleted']));
        }
    }, [props.element.version, props.element.version_saved]);

    const save = useCallback(
        debounce((id, draftId, idx, version, content) => {
            dispatch(StoriesActions.save_content(id, draftId, idx, version, content));
        }, 1000),
        []
    );

    return (
        <div style={{
            paddingTop: '2em',
            display: 'flex'
        }} onMouseOver={(e) => setHover(true)} onMouseOut={(e) => setHover(false)}>
            <div style={{
                width: '5em',
                flexGrow: 0,
                fontSize: '1.3em',
                color: '#DDDDDD',
                fontWeight: 'bold'
            }}>
                {props.type}
            </div>
            <div style={{flexGrow: 0, width: '500px'}}>
                {props.children}
            </div>
            <div style={{
                color: '#DDDDDD',
                display: 'flex',
                alignItems: 'flex-end',
                marginLeft: '1em'
            }}>
                {
                    props.readonly?null
                    :
                        (typeof props.element.version_saved === 'undefined' || props.element.version_saved == null || props.element.version > props.element.version_saved)?
                            <Icon name="circle notch loading" size="small" />
                        :
                            <Icon name="check" size="small" />
                }
            </div>
            <div style={{
                color: '#FF8800',
                display: 'flex',
                alignItems: 'flex-end',
                marginLeft: '1em'
            }}>
                {
                    props.readonly?null
                    :
                        (typeof props.element.validation === 'undefined' || props.element.validation == null || props.element.validation.length === 0)?
                            null
                        :
                            <Popup inverted content={Object.values(props.element.validation).join("\n")} trigger={<Icon name="warning sign" size="large" />} />
                }
            </div>
            <div style={{
                marginLeft: '20px',
                visibility: hover?'visible':'hidden'
            }}>
                {
                    (!props.readonly && (typeof props.removeable === 'undefined' || props.removeable !== false))?
                        <Button circular basic icon="remove" onClick={(e) => {
                            if(typeof props.onRemove === 'function') 
                                props.onRemove();
                        }} />
                    :null
                }                
            </div>
        </div>
    )
}

export const Editor = (props) => {
    moment.locale('de');
    
    const firebase = useFirebase()
    const dispatch = useDispatch()
    //const [path, setPath] = useState(props.match.params[0].split('/'));
    const firestore = useFirestore();
    const isLoading = useSelector(({stories}) => stories.selected === null || stories.selected.loading === true || stories.selected.id !== props.match.params.id);
    
    //const [elements, setElements] = useState([{type: 'title'}, {type: 'markdown', id: '5'}, {type: 'eventcard'}]);

    useEffect(() => {
        if(typeof props.match.params.id !== 'undefined' && typeof props.match.params.draftId !== 'undefined'){
            dispatch(StoriesActions.select(props.match.params.id, props.match.params.draftId));
        }
    }, [props.match.params.id]);

    const id = useSelector(({stories}) => isLoading?null:stories.selected.id);
    const isPublished = useSelector(({stories}) => isLoading?null:((typeof stories.selected.published !== 'undefined' && stories.selected.published !== null))?true:false);
    const settings = useSelector(({stories}) => isLoading?null:stories.selected.settings);
    const settings_version = useSelector(({stories}) => isLoading?null:stories.selected.version);
    const settings_version_saved = useSelector(({stories}) => isLoading?null:stories.selected.version_saved);
    const elements = useSelector(({stories}) => isLoading?null:stories.selected.content);
    const isValid = useSelector(({stories}) => isLoading?false:stories.selected.isValid);
    const validationErrors = useSelector(({stories}) => isLoading?null:stories.selected.validation);
    const draftId = useSelector(({stories}) => isLoading?null:stories.selected.draft_id);
    const isDeleted = useSelector(({stories}) => isLoading?false:((typeof stories.selected.deleted !== 'undefined' && stories.selected.deleted !== null && stories.selected.deleted))?true:false);

    useEffect(() => {
        if(!isDeleted && !isLoading && typeof props.match.params.id !== 'undefined' && props.match.params.id === id && typeof props.match.params.draftId !== 'undefined' && props.match.params.draftId !== draftId){
            dispatch(StoriesActions.create_draft(props.match.params.id, props.match.params.draftId));
        }
    }, [props.match.params.draftId, isLoading]);

    useEffect(() => {
        if(!isDeleted && elements !== null && Array.isArray(elements) && elements.length === 0 && !isPublished){
            dispatch(StoriesActions.update_content(0, {idx: 0, type: 'image'}));
            dispatch(StoriesActions.update_content(1, {idx: 1, type: 'title'}));
            dispatch(StoriesActions.update_content(2, {idx: 2, type: 'markdown'}));
        }
    }, [elements]);

    useEffect(() => {
        if(!isDeleted && !isPublished && (settings_version_saved === null || settings_version > settings_version_saved) && id !== null){
            saveSettings(id, draftId, settings_version, settings);
        }
    }, [settings_version, settings_version_saved]);

    const saveSettings = useCallback(
        debounce((id, draftId, version, settings) => {
            dispatch(StoriesActions.save_draft(id, draftId, version, settings));
        }, 1000),
        []
    );

    const isDirty = useSelector(({stories}) => {
        if(isLoading)return true;
        if(stories.selected === null)return true;
        if(settings_version_saved === null || settings_version > settings_version_saved)return true;
        if(elements === null)return true;
        if(!Array.isArray(elements))return true;
        if(typeof elements.find((el) => (typeof el.version_saved === 'undefined' || el.version_saved === null || el.version > el.version_saved)) !== 'undefined')return true;
        return false;
    });

    return (
        <StoriesNavigation breadcrumb={[
            {
                'caption': 'Beiträge',
                'href': '/stories/'
            },
            {
                'caption': (isPublished?'Veröffentlichte Version des Beitrags ':'Entwurf des Beitrags ') + "„" + ((isLoading || typeof elements === 'undefined' || elements === null || typeof elements[1] === 'undefined' || typeof elements[1].payload === 'undefined')?'- Ohne Titel -':elements[1].payload) + '”'
            }
        ]} active="files">
            {
            isDeleted?
                <div style={{
                        position: 'fixed',
                        top: '82px',
                        bottom: '0px',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            display: 'flex',
                            flexGrow: 1,
                            overflow: 'hidden'
                        }}>
                            <div style={{
                                "margin": "3em",
                                "textAlign": 'center'
                            }}>Der Beitrag wurde gelöscht.</div>
                        </div>
                        <Menu inverted attached="bottom" style={{
                            flexShrink: 0
                        }}>
                            <Menu.Item onClick={() => dispatch(RouterActions.push('/stories/'))} as='a' style={{
                                fontWeight: 500,
                                borderRight: '1px solid #555555'
                            }}>
                                <span><Icon name='chevron left' style={{}} /> Zurück zur Übersicht</span>
                            </Menu.Item>
                        </Menu>
                </div>
            :
                isLoading?
                    <Loader active inline />
                :
                    <div style={{
                        position: 'fixed',
                        top: '82px',
                        bottom: '0px',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            display: 'flex',
                            flexGrow: 1,
                            overflow: 'hidden'
                        }}>
                            <Sidebar readonly={isPublished} storyId={id} draftId={draftId} />
                            <div style={{
                                flexGrow: 1,
                                overflow: 'auto',
                                paddingBottom: '3em'
                            }}>
                                {
                                    elements.map((element, idx) => {
                                        if(element.is_deleted)return null;

                                        switch(element.type){
                                            case 'title':
                                                return (
                                                    <ElementWrapper storyId={id} draftId={draftId} idx={idx} element={element} removeable={false} readonly={isPublished}>
                                                        <Elements.Title readonly={isPublished} {...element} onChange={(value) => {
                                                            dispatch(StoriesActions.update_content(idx, {...element, payload: value}));
                                                        }} />
                                                    </ElementWrapper>
                                                )
                                            case 'markdown':
                                                return (
                                                    <ElementWrapper readonly={isPublished} storyId={id} draftId={draftId}  idx={idx} element={element} type="M↓" removeable={idx > 2} onRemove={(e) => {
                                                        dispatch(StoriesActions.update_content(idx, {...element, is_deleted: true}));
                                                        /*setElements([...elements.slice(0, idx), {
                                                            ...elements[idx],
                                                            isDeleted: true
                                                        }, ...elements.slice(idx + 1)])*/
                                                    }}>
                                                        <Elements.Markdown readonly={isPublished} {...element} onChange={(value) => {
                                                            dispatch(StoriesActions.update_content(idx, {...element, payload: value}));
                                                        }} />
                                                    </ElementWrapper>
                                                )
                                            case 'eventcard':
                                                return (
                                                    <ElementWrapper readonly={isPublished} storyId={id} draftId={draftId}  element={element} idx={idx} type="EV" removeable={idx > 2} onRemove={(e) => {
                                                        dispatch(StoriesActions.update_content(idx, {...element, is_deleted: true}));
                                                    }}>
                                                        <Elements.Eventcard readonly={isPublished} {...element} onChange={(value) => {
                                                            dispatch(StoriesActions.update_content(idx, {...element, payload: value}));
                                                        }}/>
                                                    </ElementWrapper>
                                                )
                                            case 'image':
                                                return (
                                                    <ElementWrapper readonly={isPublished} storyId={id} draftId={draftId}  element={element} idx={idx} type="IM" removeable={idx > 2} onRemove={(e) => {
                                                        dispatch(StoriesActions.update_content(idx, {...element, is_deleted: true}));
                                                    }}>
                                                        <Elements.Image readonly={isPublished} {...element} onChange={(value) => {
                                                            dispatch(StoriesActions.update_content(idx, {...element, payload: value}));
                                                        }}/>
                                                    </ElementWrapper>
                                                )
                                        }
                                    })
                                }

                                {
                                    isPublished?
                                        null
                                    :
                                        <div style={{
                                            marginTop: '1em'
                                        }}>
                                            <Elements.Selector onSelect={(type) => {
                                                dispatch(StoriesActions.update_content(elements.length, {
                                                    idx: elements.length,
                                                    type: type
                                                }));
                                            }} />
                                        </div>
                                }
                            </div>
                        </div>
                        <Menu inverted attached="bottom" style={{
                            flexShrink: 0
                        }}>
                                <Menu.Item onClick={() => dispatch(RouterActions.push('/stories/'))} as='a' style={{
                                    fontWeight: 500,
                                    borderRight: '1px solid #555555'
                                }}>
                                    <span><Icon name='chevron left' style={{}} /> Zurück zur Übersicht</span>
                                </Menu.Item>
                                <Menu.Item>
                                    {
                                        isPublished
                                            ?null
                                            :isDirty
                                                ?
                                                    <span><Icon name="circle notch" loading /> Änderungen werden gespeichert...</span>
                                                :
                                                    <span><Icon name="check" /> Alle Änderungen als Entwurf gespeichert.</span>
                                    }
                                    
                                </Menu.Item>
                                <Menu.Menu position="right" style={{
                                        display: 'flex',
                                        padding: '5px 10px'
                                }}>
                                    {isValid?
                                        null:
                                        <span style={{
                                            padding: '0 1em',
                                            color: '#FF6600',
                                            alignItems: 'center',
                                            display: 'flex'
                                        }}>
                                            <Popup inverted wide trigger={<Icon name="warning sign" size="large" />}>
                                                <Popup.Content>
                                                    Der Entwurf enthält Fehler und kann deshalb nicht veröffentlicht werden.
                                                {
                                                    (typeof validationErrors !== 'undefined' && validationErrors !== null)?
                                                        <ul>
                                                        {
                                                            Object.values(validationErrors).map((validationErrorsOfKey) => {
                                                                return (<Fragment>
                                                                    {validationErrorsOfKey.map((validationError) => 
                                                                        <li>{validationError}</li>    
                                                                    )}
                                                                </Fragment>)
                                                            })
                                                        }</ul>
                                                    :null
                                                }
                                                </Popup.Content>
                                            </Popup>
                                        </span>
                                    }
                                    {
                                        isPublished?
                                                <Fragment>
                                                    <span style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        color: '#FFFFFF',
                                                        marginRight: '1em'
                                                    }}>Der Beitrag wurde veröffentlicht.</span>
                                                    <Button onClick={(e) => {
                                                        dispatch(RouterActions.push('/stories/' + id + '/' + nanoid()))
                                                    }}>Beitrag bearbeiten</Button>
                                                </Fragment>
                                            :
                                                <Button onClick={(e) => {
                                                    if(isValid)
                                                        dispatch(StoriesActions.publish(id, draftId));
                                                }} disabled={isValid?null:true} primary content="Diese Version veröffentlichen" icon="feed" labelPosition='left' />
                                    }

                                    <Popup
                                        trigger={
                                            <Button color='red' icon='trash' />
                                        }
                                        content={<div><p>Soll der Beitrag wirklich gelöscht werden?</p><Button onClick={(e) => {
                                            dispatch(StoriesActions.remove(id, draftId));
                                        }} color='red' content='Ja, Beitrag jetzt löschen' /></div>}
                                        on='click'
                                        position='top right'
                                    />
                                    
                                </Menu.Menu>
                        </Menu>
                    </div>
                }
            
        </StoriesNavigation>
    )
}